<template>
    <div class="shared-signal-query-overview-component panel-body no-padding" v-bind:class="{loaded, loading}">
        <div class="table-responsive">
            <table class="table table-striped table-condensed table-bordered">
                <thead>
                <tr>
                    <th class="compact">
                        <a-checkbox :checked="sharedQueriesAllSelected" @change="onSelectAllChanged"
                                    :indeterminate="indeterminate" ref="globalCheckbox"/>
                    </th>
                    <th>Standaard Signalen</th>
                    <th class="compact text-center">Controleren</th>
                    <th class="compact text-center">Soort</th>
                    <th class="compact text-center">Gebruikers</th>
                    <th class="compact text-center">Afdelingen</th>
                    <th class="compact text-center">Signalen</th>
                    <th class="compact text-center">Automatisch verwerken</th>
                    <th class="compact nosort"></th>
                </tr>
                </thead>
                <tbody>
                <shared-signal-query-row-component :can-subscribe="true"
                                                   :query="sharedSignalQuery"
                                                   :selectable="selectable"
                                                   :user-id="userId"
                                                   :key="'sharedSignalQuery-' + sharedSignalQuery.id"
                                                   v-for="sharedSignalQuery in sharedSignalQueries"
                />
                <tr v-if="loading" v-for="index in 12" :key="index">
                    <td v-if="selectable">
                        <a-checkbox ref="checkbox"
                                    :disabled="true"
                                    v-on:click.stop/>
                    </td>
                    <td>
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact text-center">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 100%; display: inline-block; height: 20px; padding: 5px;"></Skeleton>
                    </td>
                    <td class="compact">
                        <Skeleton class="skeleton" :loading="true"
                                  style="width: 46px; display: inline-block; height: 32px;"></Skeleton>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="panel-footer">
            <button class="btn btn-primary" @click="attachUserToSignals(userId)">Aanmelden voor signalen</button>
        </div>
    </div>
</template>

<script>
import store from '../../../store'
import signalModule from '../store'
import sharedSignalQueryApi from '~/api/sharedSignalQuery'
import SharedSignalQueryRowComponent from './SharedSignalQueryRowComponent'
import { mapActions, mapGetters } from 'vuex'
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: 'UserQueryOverviewComponent',
  components: {
    SharedSignalQueryRowComponent,
    Skeleton
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    selectable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      sharedSignalQueries: {},
      loading: true,
      loaded: false
    }
  },

  created () {
    if (!store.hasModule('signal')) {
      store.registerModule('signal', signalModule)
    }
  },
  mounted () {
    sharedSignalQueryApi
      .paginate([], 'name', 'desc', 50)
      .then((response) => {
        this.sharedSignalQueries = response.data
        this.loading = false
      })
      .finally(() => {
        this.loaded = true
      })
  },
  computed: {
    ...mapGetters('signal', [
      'selectedSharedQueries',
      'sharedQueriesAllSelected'
    ]),
    indeterminate () {
      return this.sharedQueriesAllSelected === false
        && this.currentSelectionDiff !== this.sharedSignalQueries.length
        && this.currentSelectionDiff > 0
    },
    currentSelectionDiff () {
      if (this.sharedSignalQueries.length === undefined) {
        return false
      }
      return this.sharedSignalQueries.filter(i => this.selectedSharedQueries.findIndex(x => x.id === i.id) < 0).length
    },
  },
  methods: {
    ...mapActions('signal', [
      'selectSharedQuery',
      'deselectSharedQuery',
      'changeAllSharedQueriesSelected',
      'attachUserToSignals'
    ]),
    onSelectAllChanged () {
      this.changeAllSharedQueriesSelected()

      for (let i in this.sharedSignalQueries) {
        let query = this.sharedSignalQueries[i]

        if (this.sharedQueriesAllSelected === true && this.selectedSharedQueries.findIndex(x => x.id === query.id) < 0) {
          this.selectSharedQuery(query)
        } else if (this.sharedQueriesAllSelected === false) {
          this.deselectSharedQuery(query)
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
